var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"border alternative-text-info-container rounded"},[_c('div',{staticClass:"alternative-text-info-item grey--text text--darken-3"},[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }